import parseBoolean from "./config/parseBoolean";
import { getModelFromInputAtPosition } from '../../common/getModelFunctions';

export default {
	model: {
		value: {
			default: false
		}
	},
	computed: {
		input_set() {
			const inputs = this.$el.dataset.inputs.split(',');

			return parseBoolean(getModelFromInputAtPosition(this.$model, inputs, 1));
		},
		input_reset() {
			const inputs = this.$el.dataset.inputs.split(',');

			return parseBoolean(getModelFromInputAtPosition(this.$model, inputs, 0));
		}
	},
	watch: {
		input_set() {
			if (this.data.input_set && !this.data.input_reset) this.data.value = true;
		},
		input_reset() {
			if (this.data.input_reset) this.data.value = false;
		}
	},
	listeners: {
		click: true
	}
};
